import { motion } from 'framer-motion';
import { Target, Users, Zap, Heart } from 'lucide-react';

const missionItems = [
  {
    icon: Target,
    title: 'Empower',
    description: 'Give you the tools and knowledge to take control of your health and fitness journey.'
  },
  {
    icon: Users,
    title: 'Inspire',
    description: 'Create a motivating environment where every member feels supported and encouraged.'
  },
  {
    icon: Zap,
    title: 'Transform',
    description: 'Help you achieve lasting change, both physically and mentally, for a better life.'
  },
  {
    icon: Heart,
    title: 'Community',
    description: 'Build a strong fitness community where everyone can thrive together.'
  }
];

const Mission = () => {
  return (
    <section className="py-20 bg-power-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-4">Our Mission</h2>
          <div className="w-24 h-1 bg-power-red mx-auto"></div>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {missionItems.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center group"
            >
              <div className="bg-power-red rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <item.icon className="h-10 w-10 text-white" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-power-red">{item.title}</h3>
              <p className="text-gray-300 leading-relaxed">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Mission;
